import { DomainItem } from "../../../containers/user/organization-settings/users/DomainMultiSelect";

export function sanitizeSelectedDomains({ domainTree, selectedIds }: { domainTree: DomainItem[]; selectedIds: string[] }) {
	const parentMap: Record<string, string | null> = {};

	// Build child → parent mapping
	function buildMap(node: DomainItem, parentId: string | null = null) {
		parentMap[node.id] = parentId;

		if (node.children && node.children.length > 0) {
			node.children.forEach((child: any) => buildMap(child, node.id));
		}
	}

	// Since domainTree is an array, iterate roots
	domainTree.forEach((root) => buildMap(root));

	const selectedSet = new Set(selectedIds);

	function hasSelectedAncestor(id: string): boolean {
		let parent = parentMap[id];
		while (parent) {
			if (selectedSet.has(parent)) return true;
			parent = parentMap[parent];
		}
		return false;
	}

	return [...selectedSet].filter((id) => !hasSelectedAncestor(id));
}
